<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="loadingEstado"></loading>
    <b-row class="text-center mt-4">
      <b-col cols="1" md="3">
      </b-col>
      <b-col cols="9" md="6" >
        <b-row class="contenedorTablaSinColor" style="background:white ">
          <b-col cols="10" lg="11" class="pr-0">
            <b-input-group class="pl-3" >
              <b-form-input
                  class="input-filter"
                  v-model="filtro.nombreEstadoPromocion"
                  type="search"
                  id="filterInput"
                  responsive
                  placeholder="Búsqueda del estado de la promoción"
                  @keydown.enter.native="buscarEstadoPromocion()"
              >
              </b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="2" lg="1" class="pl-0">
        <b-button
            class="mt-1 pb-1"
            size="sm"
            variant="info"
            :disabled="loading"
            responsive
            @click="buscarEstadoPromocion"
        >
              <span v-if="!loading"
              >
                <em class="buscar_svg primary sm"></em>
              </span>
          <span v-else><b-spinner small></b-spinner></span>
        </b-button>
      </b-col>
      <b-col cols="1" class="text-left mt-auto mb-auto">
        <b-button
            variant="primary"
            v-b-tooltip.hover
            title="Alta de Estado Promocion"
            class="paddingbotones botonesAzulFuerte"
            @click="altaEstadoPromo()"
            responsive
            v-if="$localStorageService.can('Cat_est_alta')"
        ><em class="vale_svg icon-boton"></em>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12" lg="12" class="contenedorTablaSinColor mt-5">
        <b-table
            :hover="true"
            :small="true"
            style="font-size: 12px !important; padding: 0.1rem;"
            responsive
            fixed
            :fields="fields"
            :items="items"
            :per-page="registrosPorPagina"
            :current-page="currentPage"
            thead-tr-class="columnasTablaSinColorLetter"
        >
          <template v-slot:cell(fechaAlta)="row">
            {{ row.item.fechaAlta | formatoFechaCorta }}
          </template>
          <template v-slot:cell(fechaModificacion)="row">
            {{ row.item.fechaModificacion | formatoFechaCorta }}
          </template>
          <template v-slot:cell(Acciones)="row" style="width: 200px">
            <b-button size="sm" variant="warning" class="mr-1 mt-1 marginbotones"
                      v-if="$localStorageService.can('Cat_est_edit') && row.item.registroActivo"
                      v-b-tooltip.hover
                      title="Editar"
                      @click="editarEstadoPromoModal(row.item)">
              <em class="editar_svg sm"></em>
            </b-button>

            <b-button size="sm" variant="outline-success" class="mr-1 mt-1 marginbotones"
                      v-if="!row.item.registroActivo && $localStorageService.can('Cat_est_inact')"
                      v-b-tooltip.hover
                      title="Activar"
                      @click="desactivarActivar(row.item)">
              <em class="fa fa-undo"></em>
            </b-button>
            <b-button size="sm" variant="danger" class="mr-1 mt-1 marginbotones paddingbotones"
                      v-if="row.item.registroActivo && $localStorageService.can('Cat_est_React')"
                      v-b-tooltip.hover
                      title="Dar de baja"
                      @click="desactivarActivar(row.item)">
              <em class="eliminar_svg icon-boton"></em>
            </b-button>
          </template>
        </b-table>
        <div align="center" v-if="loading">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <b-col v-else>
          <b-alert v-if="items.length === 0" variant="warning" show>No hay datos</b-alert>
        </b-col>
      </b-col>
      <div class="mt-2 w-100 flex justify-content-center align-items-end">
        <b-pagination
            align="center"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="registrosPorPagina"
        ></b-pagination>
      </div>
    </b-row>
    <b-modal
        v-model="mostrarModal"
        size="xl"
        class="redondeo"
        centered
        :no-close-on-backdrop="true"
        hide-footer>
       <alta-estado-promocion
           ref="modalModificar"
           v-if="mostrarModal"
           :estadoOriginal="estadoPromoSeleccionada"
           @actualizar="actuaBuscarEstadoPromocion"
           @cancelar="mostrarModal=false;"
       >

       </alta-estado-promocion>
    </b-modal>
  </div>
</template>

<script>
import altaEstadoPromocion from "./altaEstadoPromocion";
export default {
  name: "listaEstadoPromocion",
  components: {
    altaEstadoPromocion
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      loadingEstado: false,
      loading: false,
      filtro:{
        nombreEstadoPromocion: ''
      },
      fields: [
        {key: "idEstadoPromocion", label: "ID Estado Promoción", sortable: true},
        {key: "nombreEstadoPromocion", label: "Nombre Estado Promoción", sortable: true},
        {key: "descripcionEstadoPromocion", label: "Descripción Estado Promoción", sortable: true},
        {key: "fechaAlta", label: "Fecha Alta", sortable: true},
        {key: "fechaModificacion", label: "Fecha Modificación", sortable: true},
        {key: "usuarioModificacion", label: "Usuario Modificación", sortable: true},
        "Acciones",
      ],
      currentPage: 1,
      items: [],
      registrosPorPagina:10,
      mostrarModal: false,
      estadoPromoSeleccionada: null
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
    this.buscarEstadoPromocion();
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  watch:{
    "filtro.nombreEstadoPromocion": async function () {
      if(this.filtro.nombreEstadoPromocion === ''){
        setTimeout(() => {
          this.buscarEstadoPromocion();
        }, 500)
      }
    }
  },
  methods: {
    buscarEstadoPromocion() {
      this.currentPage = 1;
      this.loading = true;
      this.items = [];
      this.$http
          .post(this.$api + "estadoPromocion/obtenerEstadosPromocion",this.filtro)
          .then((response) => {
            this.items = response.data.data;
          }).finally(() => {
        this.loading = false;
      });
    },
    actuaBuscarEstadoPromocion(filtro) {
      this.currentPage = 1;
      this.loading = true;
      this.items = [];
      this.$http
          .post(this.$api + "estadoPromocion/obtenerEstadosPromocion",filtro)
          .then((response) => {
            this.items = response.data.data;
          }).finally(() => {
        this.loading = false;
      });
    },
    desactivarActivar(item) {
      const mensaje = item.registroActivo ?'¿Está seguro de desactivar el estado promoción?': '¿Está seguro de activar el estado promoción?';

      this.$swal.fire({
        icon: "warning",
        text: mensaje,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,

        preConfirm: () => {
          this.loading = true;
          this.$http
              .post(this.$api + "estadoPromocion/activarDesactivarEstadosPromocion", item)
              .then((response) => {
                if (response.data.data) {
                  this.buscarEstadoPromocion();
                  this.$swal.fire({
                    position: "center",
                    icon: "info",
                    title: "Aviso",
                    text:  item.registroActivo ?'Se desactivó el estado de la promoción': 'Se activo el estado de la  promoción',
                    showConfirmButton: false,
                    timer: 3500,
                  });
                }
              });
        },
      });
    },
    altaEstadoPromo() {
      this.mostrarModal = true;
      this.titulo = "Nuevo estado promoción";
      this.estadoPromoSeleccionada = null;
      this.mostrarGuardar = true;
    },
    editarEstadoPromoModal(item) {
      this.estadoPromoSeleccionada = item;
      this.mostrarGuardar = false;
      this.mostrarModal = true;
      this.titulo = "Modificar categoria estado";
    },
  }
}
</script>

<style scoped>
.paddingbotones {
  padding: 5px;
}
.icon-boton {
  filter: brightness(0) invert(1);
  height: 20px;
  display: block;
}
.botonesAzulFuerte {
  border-radius: 10rem;
  color: #fff;
  background-color: var(--color-icono);
  border-color: var(--color-icono);
  margin-left: 5%;
}
</style>
